var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeloPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.84 41.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "selo_premium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,25.86v16l8.52-4.73V28.59A14.62,14.62,0,0,1,5,25.86Z",
    transform: "translate(0 0)",
    fill: "#121d2e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.51,28.59v8.5L22,41.82v-16a14.56,14.56,0,0,1-8.51,2.73Z",
    transform: "translate(0 0)",
    fill: "#385799",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33,20.52A2.22,2.22,0,0,1,.19,17.6l1.36-3.09a2.2,2.2,0,0,0,0-1.69L.36,9.68A2.21,2.21,0,0,1,1.61,6.81L4.75,5.58A2.16,2.16,0,0,0,6,4.41L7.33,1.32A2.22,2.22,0,0,1,10.25.19l3.08,1.35a2.23,2.23,0,0,0,1.7,0L18.17.35A2.22,2.22,0,0,1,21,1.61l1.22,3.14A2.22,2.22,0,0,0,23.43,6l3.09,1.36a2.21,2.21,0,0,1,1.14,2.91L26.3,13.33a2.23,2.23,0,0,0,0,1.7l1.22,3.14A2.21,2.21,0,0,1,26.23,21l-3.14,1.23a2.29,2.29,0,0,0-1.22,1.17l-1.35,3.09a2.22,2.22,0,0,1-2.92,1.14L14.51,26.3a2.2,2.2,0,0,0-1.69,0L9.68,27.49a2.21,2.21,0,0,1-2.87-1.25L5.58,23.1a2.16,2.16,0,0,0-1.17-1.22L1.33,20.52Z",
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.92,24.8A10.88,10.88,0,1,1,24.8,13.92,10.89,10.89,0,0,1,13.92,24.8Zm0-19.86a9,9,0,1,0,9,9A9,9,0,0,0,13.92,4.94Z",
    transform: "translate(0 0)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.24,17.77h1.18v1H10.94v-1h1v-7.7h-1v-1h3.6a4.24,4.24,0,0,1,2.74.77,2.72,2.72,0,0,1,.93,2.23,2.71,2.71,0,0,1-1,2.2,4.23,4.23,0,0,1-2.71.79h-1.3Zm0-7.72v4.09h1.17a2.94,2.94,0,0,0,1.87-.51,1.88,1.88,0,0,0,.63-1.53,1.8,1.8,0,0,0-.68-1.53,3.31,3.31,0,0,0-2-.51h-1Z",
    transform: "translate(0 0)",
    fill: "gray"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeloPremium);
export default __webpack_public_path__ + "static/media/selo_premium.4fb848f79e40347d0a3d037d3d478f00.svg";
export { ForwardRef as ReactComponent };